import URLS from 'constant/notifications'

export const getURL = (message) => {
    const { topic, actor_id, subject_id, subject, data } = message;
    let url;
    if (topic === 'CONVO_ADMIN_REMINDER') {
      return `/inbox/convo/${data.convo_id}?mid=${subject_id}`;
    }
    if (topic === 'DEADLINES_CHANGE_REQUESTED') {
      return `/colleges/errors`;
    }
    if (topic === 'TIMELOG_REJECTED') {
      return '/time-tracker';
    }
    if (URLS[topic] && actor_id) {
      subject !== 'student_milestone_exercises'
        ? (url = `/students/${actor_id}/${URLS[topic]}`)
        : (url = `/students/${actor_id}/${URLS[topic]}/${subject_id}/view`);
    } else return '#';

    return url;
  };
